import React from 'react';
import './Menu.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './main/Styling/Navbar.css'
import { Route, Routes } from "react-router-dom";
import { ItemPage, ContactUs, CartRequest, NoMatch } from './main/Components/MenuWebsite/MainPages';
import ImageSlider from './main/Components/MenuWebsite/ImageSlider/ImageSlider';
import SponsorsPage from './main/Components/MenuWebsite/MainPages/SponsorsPage';
import SearchPage from './main/Components/MenuWebsite/MainPages/SearchPage';
import MenuCatigoriesMain from './main/Components/MenuWebsite/MainPages/MenuCatigoriesMain';
import MenuSubCatigory from './main/Components/MenuWebsite/MainPages/MenuSubCatigory';
import ItemList from './main/Components/MenuWebsite/MainPages/ItemList';
import FrontPage from './main/Components/HomeWebsite/FrontPage';
import AboutUs from './main/Components/HomeWebsite/AboutUs';
import OurMenus from './main/Components/HomeWebsite/OurMenus';
import ForRestaurants from './main/Components/HomeWebsite/ForRestaurants';
import ForDispensaries from './main/Components/HomeWebsite/ForDispensaries';
import ForGolf from './main/Components/HomeWebsite/ForGolf';
import ForHotels from './main/Components/HomeWebsite/ForHotels';
import ForStores from './main/Components/HomeWebsite/ForStores';
import ForCruises from './main/Components/HomeWebsite/ForCruises';
import ForVenues from './main/Components/HomeWebsite/ForVenues';
import MainContactUs from './main/Components/HomeWebsite/MainContactUs';
import { TreeProvider } from './main/Context/TreeContext';


function App() {

  return (
    <TreeProvider>
      <div id="app-root" className='App'>
        <Routes>
          <Route path='/' element={ <FrontPage /> } />
          <Route path='/About-Us' element={ <AboutUs /> } />
          <Route path='/Our-Menus' element={ <OurMenus /> } />
          <Route path='/Restaurants' element={ <ForRestaurants /> } />
          <Route path='/Hotels' element={ <ForHotels /> } />
          <Route path='/Dispensaries' element={ <ForDispensaries /> } />
          <Route path='/Golf' element={ <ForGolf /> } />
          <Route path='/Stores' element={ <ForStores /> } />
          <Route path='/Venues' element={ <ForVenues /> } />
          <Route path='/Cruises' element={ <ForCruises /> } />
          <Route path='/Contact-Us' element={ <MainContactUs /> } />
          <Route path='/v2/:location' element={<MenuCatigoriesMain />} />
          <Route path='/v2/:location/:menuId' element={<MenuSubCatigory />} />
          <Route path='/v2/:location/:menuId/:submenuId' element={<MenuSubCatigory />} />
          <Route path='/v2/:location/:menuId/items' element={<ItemList />} />
          <Route path='/v2/:location/:menuId/:submenuId/items' element={<ItemList />} />
          <Route path='/v2/:location/:menuId/items/:item' element={<ItemPage />} />
          <Route path='/v2/:location/:menuId/:submenuId/items/:item' element={<ItemPage />} />
          <Route path='/v2/:location/ContactUs' element={<ContactUs />} />
          <Route path='/v2/:location/CartRequest' element={<CartRequest />} />
          <Route path='/v2/:location/Sponsors' element={<SponsorsPage />} />
          <Route path='/v2/:location/Search' element={<SearchPage />} />
          <Route path="*" element={<NoMatch status={404} />} />
        </Routes>
        <ImageSlider />
      </div>
    </TreeProvider>
  );
}

export default App;
